import { stopImpersonation } from '@adornis/users/client/impersonation.js';
import { currentUser, isImpersonating } from '@adornis/users/client/currentUser.js';
import { useEffect, useState } from 'react';

export function ImpersonationBanner() {
  const [active, setActive] = useState(false);
  const [victimEmail, setVictimEmail] = useState<string | null>(null);
  const [stopping, setStopping] = useState(false);

  useEffect(() => {
    const sub = isImpersonating.subscribe(value => setActive(value));
    return () => sub.unsubscribe();
  }, []);

  useEffect(() => {
    if (!active) return;
    const sub = currentUser<any>().subscribe((user: any) => {
      setVictimEmail(user?.email ?? user?.username ?? user?._id ?? null);
    });
    return () => sub.unsubscribe();
  }, [active]);

  if (!active) return null;

  const handleStop = async () => {
    setStopping(true);
    try {
      await stopImpersonation();
      window.location.href = '/';
    } finally {
      setStopping(false);
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-white px-4 py-2 flex items-center justify-between text-sm font-medium shadow-md">
      <span>
        Impersonation aktiv{victimEmail ? `: ${victimEmail}` : ''}
      </span>
      <button
        type="button"
        onClick={handleStop}
        disabled={stopping}
        className="ml-4 px-3 py-1 bg-white text-amber-600 rounded font-semibold hover:bg-amber-50 disabled:opacity-60 transition-colors"
      >
        {stopping ? 'Wird beendet…' : 'Impersonation beenden'}
      </button>
    </div>
  );
}
